import getSupportedDealTypes from './getSupportedDealTypes.js';
import getSelectedCriteria from './getSelectedCriteria.js';
import getPriceSettings from './getPriceSettings.js';

/**
 * Builds the calculator configuration for a non-syndicated vehicle details page given listing, payments, and interest
 * rates from a non-syndicated VDP.
 * @param {*} listing - The listing object from LSC.
 * @param {*} payments - The payments object from the payments calculation service.
 * @param {*} interestRates - The interest rates object.
 * @param {*} paymentCalculationFetcher - The paymentCalculationFetcher object.
 * @param paymentIncentivesFetcher
 * @param isEcommHyundai
 * @returns the calculator configuration object
 */
async function buildCalculatorConfig() {
  let listing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let payments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let interestRates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let paymentCalculationFetcher = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let paymentIncentivesFetcher = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  let isEcommHyundai = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  const {
    paymentServices: {
      digitalRetailingType = '',
      dealerSettings = {},
      paymentCalculationUrl = ''
    } = {},
    pricingDetail: {
      salePrice,
      msrp
    } = {},
    esntial = {},
    owner = {},
    ecommWebsite = {},
    zip
  } = listing;
  const {
    privateSeller,
    hideEmailForm,
    location = {}
  } = owner;
  const {
    defaultFinanceTerms,
    disableTrade,
    priceBreakdownEnabled,
    shortCustomDisclaimer
  } = dealerSettings;
  const {
    paymentOption = 'finance'
  } = payments;
  const listingPrice = salePrice || msrp;
  const isPsx = digitalRetailingType === 'psx';
  const esntialDeepLink = !!Object.keys(esntial).length && !!Object.keys(ecommWebsite).length ? ecommWebsite : {};
  const isHyundaiEsntialEligible = isEcommHyundai && !!Object.keys(esntialDeepLink).length;
  return {
    msrp,
    listingPrice,
    digitalRetailingType,
    disableTrade,
    shopperZip: zip,
    dealerZip: location?.address?.zip,
    defaultFinanceTerms,
    disclaimerKey: isPsx ? 'PSX' : 'default',
    disableIncentives: isPsx || !priceBreakdownEnabled,
    enablePriceDetailsInOfferBreakdown: priceBreakdownEnabled && !isPsx,
    enablePayoffQuote: !Object.keys(esntial).length,
    esntialDeepLink,
    enableLenderDisclaimerCTA: !hideEmailForm && !isHyundaiEsntialEligible,
    ...(await getSupportedDealTypes(dealerSettings, digitalRetailingType, paymentOption)),
    ...(await getSelectedCriteria(dealerSettings, payments, listingPrice, interestRates)),
    ...(await getPriceSettings(dealerSettings)),
    interestRates,
    hideSendOfferCTA: isHyundaiEsntialEligible || digitalRetailingType !== 'accelerate' && (hideEmailForm || privateSeller),
    isDueAtSigningAmountDeduct: paymentCalculationUrl?.includes('leaseDeductDueAtSigning=true'),
    paymentCalculationUrl,
    paymentCalculationFetcher,
    paymentIncentivesFetcher,
    showLenderDisclaimer: !isPsx,
    showRatesTable: true,
    showWalletSyncBanner: true,
    listing,
    shortCustomDisclaimer,
    isEcommHyundai
  };
}
export { buildCalculatorConfig as default };
